import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { auth } from '../../../config/Fire';
import { setLogout } from '../../../actions/user';
import { getUser, getCompanies } from '../../../reducers';
import * as Constants from '../../../constants';
import LoadingPage from '../../components/LoadingPage';
import MainMenuEmployee from '../../components/MainMenuEmployee';
import { getAllCompanies } from '../../../actions/company/getAllCompanies';
import WarningDimensions from '../../components/WarningDimensions';
import ChatEmployee from '../ChatEmployee';
import ChatHistoricalEmployee from '../ChatHistoricalEmployee';
import WorksEmployee from '../WorksEmployee'
import WorksEmployeeResume from '../WorksEmployeeResume'
import WorksEmployeeCalendar from '../WorksEmployeeCalendar'
import WorksTripsEmployee from '../WorksTripsEmployee'
// Comentado: Registros movido al menú de usuarios REGISTER
// import Registers from '../../admin/Registers'
import OutsourcingEmployee from '../OutsourcingEmployee';
import BidsEmployee from '../BidsEmployee';
import ClientsEmployee from '../ClientsEmployee';
import InventoryHistorical from '../../client/InventoryHistorical'
import DetailsWork from '../../employee/WorksEmployee/DetailsWork'

const { Content, Footer } = Layout;

class MainEmployee extends Component {
    state = {
        itemSelected: Constants.MenuEmployee.CHAT
    }

    onItemClick = ({itemClickType}) => {
        switch (itemClickType) {
            case Constants.MenuEmployee.CHAT:
                this.props.history.push(`/${Constants.MenuEmployee.WORKS.ARCASA}`);
                break;
            case Constants.MenuEmployee.LOGOUT:
                this.props.setLogout();
                auth.signOut();
                this.props.history.push(`/`);
                break;
            default:
                this.props.history.push(`/${itemClickType}`);
                break;
        }
        this.setState({ itemSelected: itemClickType });
    }

    handlerGetInfo = () => {
        this.props.getAllCompanies();
        return <LoadingPage />
    }

    render() {
        const { location, companies, user } = this.props;
        return (
            <div>
                {
                    companies ?
                        <Layout>
                            <MainMenuEmployee onItemClick={this.onItemClick} itemSelected={location.pathname} user={user}/>
                            {
                                window.innerWidth >= 768 ?
                                    <Content>
                                        <div style={{ margin: '0', padding: 16, background: '#fff', minHeight: '90vh' }}>
                                            {
                                                Constants.UsersWithPermissions.includes(user.email) &&
                                                <span>
                                                        <Route exact path={`/${Constants.MenuEmployee.INVENTORY_HISTORICAL}`} component={ InventoryHistorical } />
                                                    </span>
                                            }
                                            {/* Comentado: Registros movido al menú de usuarios REGISTER
                                            {
                                                user && user.id && Constants.VALID_USERS_IDS.includes(user.id) &&
                                                <Route exact path={`/${Constants.MenuEmployee.REGISTERS}`} component={ Registers } />
                                            }
                                            */}
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.BID.ARCASA}`}
                                                render={(props) => <BidsEmployee {...props} companyType="Arcasa" />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.BID.SD}`}
                                                render={(props) => <BidsEmployee {...props} companyType="SD" />}
                                            />
                                            {/* <Route  exact path={`/${Constants.MenuEmployee.WORKS}`} component={ WorksEmployee } /> */}
                                            <Route  exact path={`/${Constants.MenuEmployee.CLIENTS}`} component={ ClientsEmployee } />
                                            <Route  exact path={`/${Constants.MenuEmployee.OUTSOURCING}`} component={ OutsourcingEmployee } />
                                            <Route  exact path={`/${Constants.MenuEmployee.HISTORICAL_CHAT}`} component={ ChatHistoricalEmployee } />
                                            <Route path={`/${Constants.MenuEmployee.EDIT_WORK}`} component={ DetailsWork}/>
                                            {/* <Route  exact path="/" component={ ChatEmployee } /> */}
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.RESUME.SD}`}
                                                render={(props) => <WorksEmployeeResume {...props} resumeType={Constants.MenuEmployee.RESUME.SD} />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.RESUME.ARCASA}`}
                                                render={(props) => <WorksEmployeeResume {...props} resumeType={Constants.MenuEmployee.RESUME.ARCASA} />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.WORKS.ARCASA}`}
                                                render={(props) => <WorksEmployee {...props} companyType="Arcasa" />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.WORKS.SD}`}
                                                render={(props) => <WorksEmployee {...props} companyType="SD" />}
                                            />
                                            <Route exact path="/">
                                                <Redirect to={`/${Constants.MenuEmployee.WORKS.ARCASA}`} />
                                            </Route>
                                            <Route  exact path={`/${Constants.MenuEmployee.WORKS.CALENDAR}`} component={ WorksEmployeeCalendar } />
                                            <Route  exact path={`/${Constants.MenuEmployee.WORKS.TRIPS}`} component={ WorksTripsEmployee } />
                                        </div>
                                    </Content>
                                    :
                                    <Content>
                                        <div style={{ margin: '0', padding: 16, background: '#fff', minHeight: '90vh' }}>
                                            {
                                                Constants.UsersWithPermissions.includes(user.email) &&
                                                <span>
                                                        <Route  exact path={`/${Constants.MenuEmployee.INVENTORY_HISTORICAL}`} component={ InventoryHistorical } />
                                                    </span>
                                            }
                                            {/* Comentado: Registros movido al menú de usuarios REGISTER
                                            {
                                                user && user.id && Constants.VALID_USERS_IDS.includes(user.id) &&
                                                <Route exact path={`/${Constants.MenuEmployee.REGISTERS}`} component={ Registers } />
                                            }
                                            */}
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.BID.ARCASA}`}
                                                render={(props) => <BidsEmployee {...props} companyType="Arcasa" />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.BID.SD}`}
                                                render={(props) => <BidsEmployee {...props} companyType="SD" />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.RESUME.SD}`}
                                                render={(props) => <WorksEmployeeResume {...props} resumeType={Constants.MenuEmployee.RESUME.SD} />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.RESUME.ARCASA}`}
                                                render={(props) => <WorksEmployeeResume {...props} resumeType={Constants.MenuEmployee.RESUME.ARCASA} />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.WORKS.ARCASA}`}
                                                render={(props) => <WorksEmployee {...props} companyType="Arcasa" />}
                                            />
                                            <Route
                                                exact
                                                path={`/${Constants.MenuEmployee.WORKS.SD}`}
                                                render={(props) => <WorksEmployee {...props} companyType="SD" />}
                                            />
                                            <Route  exact path={`/${Constants.MenuEmployee.WORKS.CALENDAR}`} component={ WorksEmployeeCalendar } />
                                            <Route  exact path={`/${Constants.MenuEmployee.WORKS.TRIPS}`} component={ WorksTripsEmployee } />
                                            <Route  exact path={`/${Constants.MenuEmployee.CLIENTS}`} component={ ClientsEmployee } />
                                            <Route  exact path={`/${Constants.MenuEmployee.OUTSOURCING}`} component={ OutsourcingEmployee } />
                                            <Route  exact path={`/${Constants.MenuEmployee.HISTORICAL_CHAT}`} component={ WarningDimensions } />
                                            <Route exact path="/">
                                                <Redirect to={`/${Constants.MenuEmployee.WORKS.ARCASA}`} />
                                            </Route>
                                        </div>
                                    </Content>
                            }
                            <Footer style={{ textAlign: 'center', padding: "8px 50px" }}>
                                Copyright - Sitio desarrollado por <a href="https://www.autosolve.com.ar/" target="_blank" rel="noopener noreferrer">AutoSolve</a> | Todos los derechos reservados ©2020
                            </Footer>
                        </Layout>
                        :
                        this.handlerGetInfo()
                }
            </div>
        );
    }
}

MainEmployee.propTypes = {
    setLogout: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setLogout: value => dispatch(setLogout(value)),
    getAllCompanies: value => dispatch(getAllCompanies(value)),
});

const mapStateToProps = state => ({
    user:  getUser(state),
    companies:  getCompanies(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(MainEmployee));
